"use client";

import CalendarDaysIcon from "@heroicons/react/24/outline/CalendarDaysIcon";
import { VENUE_TABS } from "@/@core/constants/venue-tabs";
import EventList from "@/components/views/events/EventList";

interface Props {
  events: Event.Detail[];
  venue: Venue.Detail;
}

export default function VenueDetailEvents(props: Props) {
  return (
    <>
      {props.events.length > 0 && (
        <div
          id={VENUE_TABS.EVENTS}
          className="flex flex-col mt-6 mb-6 lg:max-w-[895px] border rounded-[32px] px-4 pt-4 pb-2 gap-4"
        >
          <div className="flex bg-stone-50 rounded-[16px] py-1.5 px-2 gap-2">
            <CalendarDaysIcon className="size-5 text-primary" />
            <h2 className="text-primary font-bold text-sm">Etkinlikler</h2>
            <div className="py-[2px] cursor-default px-[6px] text-xs bg-primary text-white font-[500] rounded-full">
              {props.events.length}
            </div>
          </div>

          <div className="items-center grid grid-cols-1 md:grid-cols-2 md:w-auto w-full gap-4 pb-2 md:custom-scrollbar">
            <EventList
              titleHeadingLevel="h3"
              venue={props.venue}
              events={props.events}
            />
          </div>
        </div>
      )}
    </>
  );
}
